import React from "react";
import PageContent from "./PageContent";

const PrivacyPolicy = () => {
    return <PageContent slug="privacy-policy" />;
};

export default PrivacyPolicy;
